module.exports = __webpack_public_path__ + "static/media/28DGC7.d456fac1.jpg";